<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button color="primary" (click)="closeModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title class="ion-text-center"> Support </ion-title>
  </ion-toolbar>
</ion-header>


<ion-content class="ion-padding">

  <div class="chat-container">
    <div *ngIf="!hideSkeleton" class="message-wrapper">
      <div *ngFor="let message of messages | async" [ngClass]="message.myMsg ? 'msg-row-me' : 'msg-row-other'">

        <div class="bubble-container">
          <div class="sender-name" *ngIf="!message.myMsg">{{ message.fromName }}</div>
          <div class="chat-bubble" [ngClass]="message.myMsg ? 'glass-card neon-border-primary' : 'glass-card'">
            <div class="msg-content">{{ message.msg }}</div>
            <div class="msg-time">{{ message.createdAt?.toMillis() | date:'shortTime' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div *ngIf="hideSkeleton">
    <ion-item lines="none" *ngFor="let item of skeletOns">
      <ion-thumbnail>
        <ion-skeleton-text [animated]="true" style="width: 250px; height: 400px;"></ion-skeleton-text>
      </ion-thumbnail>
    </ion-item>

    <ion-item lines="none" *ngFor="let item of skeletOns">
      <ion-thumbnail>
        <ion-skeleton-text [animated]="true" style="width: 250px; height: 400px; left: 100px"></ion-skeleton-text>
      </ion-thumbnail>
    </ion-item>
  </div>




  <ion-list class="ion-no-padding" lines="none">
    <ion-img *ngIf="hasNoData" src="../../../assets/imgs/chat.svg"></ion-img>
    <ion-list-header *ngIf="hasNoData" style="margin-top: 10%">
      <ion-label color="primary" class="ion-text-center">
        <h1>We Respond Immediately</h1>
        <p>Tell Us How We can Help You.</p>
      </ion-label>
    </ion-list-header>
  </ion-list>

</ion-content>

<ion-footer class="ion-no-border glass-panel">
  <ion-toolbar class="transparent-toolbar">
    <ion-row class="ion-align-items-center ion-padding-horizontal">
      <ion-col size="10">
        <ion-textarea autoGrow="true" (ionFocus)="Show()" (ionBlur)="Hide()" placeholder="Transmission starts here..."
          class="cyber-input" rows="1" maxLength="500" [(ngModel)]="newMsg">
        </ion-textarea>
      </ion-col>
      <ion-col size="2">
        <ion-button fill="clear" [disabled]="newMsg === ''" class="send-btn" (click)="sendMessage()">
          <ion-icon name="send-outline" slot="icon-only"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>